import React, { useState } from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import BlockIcon from '@mui/icons-material/Block';
import Button from '@mui/material/Button';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, keep the ascending order */

const useStyles = makeStyles(theme => ({
    toggleContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: theme.spacing(2),
    },
    textArea: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    actions: {
        padding: theme.spacing(2),
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    includeBtn: {
        ...theme.typography.button,
        '&.Mui-selected': {
            color: '#0eafa0',
        },
    },
    excludeBtn: {
        ...theme.typography.button,
        '&.Mui-selected': {
            color: '#d32f2f',
        },
    },
    icon: {
        marginRight: theme.spacing(1),
    },
}));

const ImportAudiencesModal = ({ open, onClose, onImport }) => {
    const classes = useStyles();
    const [mode, setMode] = useState('include');
    const [text, setText] = useState('');

    const handleModeChange = (event, newMode) => {
        if (newMode !== null) {
            setMode(newMode);
        }
    };

    const handleImport = () => {
        onImport(text, mode);
        onClose();
        setText('');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle disableTypography className={classes.dialogTitle}>
                <Typography variant="h6">Import Audiences</Typography>
                <ToggleButtonGroup
                    value={mode}
                    exclusive
                    onChange={handleModeChange}
                    aria-label="audience mode"
                    size="small"
                >
                    <ToggleButton
                        value="include"
                        aria-label="include"
                        id={
                            mode === 'include'
                                ? 'import-audience-include-btn-active'
                                : 'import-audience-include-btn'
                        }
                        className={classes.includeBtn}
                    >
                        <CheckCircleOutlineIcon className={classes.icon} />
                        Include
                    </ToggleButton>
                    <ToggleButton
                        value="exclude"
                        aria-label="exclude"
                        id={
                            mode === 'exclude'
                                ? 'import-audience-exclude-btn-active'
                                : 'import-audience-exclude-btn'
                        }
                        className={classes.excludeBtn}
                    >
                        <BlockIcon className={classes.icon} />
                        Exclude
                    </ToggleButton>
                </ToggleButtonGroup>
            </DialogTitle>
            <DialogContent dividers>
                <TextField
                    className={classes.textArea}
                    multiline
                    rows={10}
                    placeholder={`Paste your audience IDs here
Flex audiences are not allowed
Please add one ID per line`}
                    variant="outlined"
                    value={text}
                    onChange={e => setText(e.target.value)}
                    fullWidth
                />
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleImport} color="primary" variant="contained">
                    Import
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportAudiencesModal;
